import React, { useEffect, useState } from "react";
import axios from "axios";
import VideoCard from "../components/VideoCard";
import { Container, Row, Col } from "react-bootstrap";

function Feed() {
  const [videos, setVideos] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const currentUserEmail = currentUser?.email;

  useEffect(() => {
    if (!currentUserEmail) return;

    axios
      .get(`/api/videos/friends-feed/${encodeURIComponent(currentUserEmail)}`)
      .then((res) => setVideos(res.data))
      .catch((err) => console.error("Erreur feed amis :", err));
  }, [currentUserEmail]);

  return (
    <Container className="mt-4">
      <h2 className="text-center mb-4 text-white">👥 Vidéos des amis</h2>
      <Row>
        {videos.length === 0 ? (
          <p className="text-muted text-center">
            Aucune vidéo publiée par vos amis.
          </p>
        ) : (
          videos.map((video) => (
            <Col key={video.id} xs={12} className="mb-4">
              <VideoCard
                video={video}
                currentUserEmail={currentUserEmail}
                currentUserPseudo={currentUser?.pseudo}
                isMyVideo={video.user_email === currentUserEmail}
              />
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
}

export default Feed;
